




































































































































































































import { Vue, Component } from "vue-property-decorator";
import HotelPolicyService from "@/service/hotelPolicyService";
import { Swipe, Calendar, SwipeItem, Rate, Dialog, Toast, Overlay } from "vant";
// import { , Rate, Skeleton, Overlay, Loading, List, PullRefresh, Empty } from "vant";
import * as _ from "lodash";
import productDetailsHeader from "../modules/productDetails.vue";
import dataShare from "@/views/mall/dataShare";
import { ApplyArea, ServiceType } from "@/model/Base";
import SystemService from "@/service/UserService";
import moment from "moment";

@Component({
  name: "hotelInfo",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Rate.name]: Rate,
    [Overlay.name]: Overlay,
    [Calendar.name]: Calendar,
    productDetailsHeader: productDetailsHeader,
  },
})
export default class HotelInfo extends Vue {
  //data
  flightDetailList = [];
  productDetailData: object = {};
  productImgs: string[] = [];
  WIFIIcon = require("@/assets/WIFI.png");
  stopIcon = require("@/assets/parking.png");
  sportIcon = require("@/assets/Bodybuilding.png");
  baggageIcon = require("@/assets/luggage.png");
  navigationIcon = require("@/assets/Navigation.png");
  noImages = require("@/assets/noPictures.png");

  isGoodBreakfast = true;
  isRoomBedType = false;
  isRoomWindow = true;

  isShowCalendar = false;
  // hotelDate: any = [];

  get hotelDate() {
    const query: any = this.$route.query || {};
    if (query.DepartDate && query.ArriveDate) {
      return [moment(query.DepartDate).toDate(), moment(query.ArriveDate).toDate()];
    }
    return [];
  }
  get lang() {
    return this.$i18n.locale;
  }
  get isDisabledReserve() {
    return !this.$route.query.approvalCode && this.disabledReserve;
  }

  hotelFormatter(day?: any) {
    if (day.type === "start") {
      day.bottomInfo = "入住";
    } else if (day.type === "end") {
      day.bottomInfo = "离店";
    }
    return day;
  }

  handleSelectDate(dates: any) {
    this.isShowCalendar = false;
    const queryData = JSON.parse(JSON.stringify(this.$route.query));
    queryData.DepartDate = (this as any).$moment(dates[0]).format("YYYY-MM-DD");
    queryData.ArriveDate = (this as any).$moment(dates[1]).format("YYYY-MM-DD");

    queryData.Wheres = JSON.stringify([
      {
        ConsumerDate: queryData.DepartDate,
        FinishedDate: queryData.ArriveDate,
      },
    ]);
    this.$router.replace({ path: "/mall/hotel/details", query: queryData });
    this.isShowSkeleton = true;
    this.getDetailData();
  }

  isShow = false;

  dataShare = dataShare;

  consumers = [];
  isShowSkeleton = false;
  filterCondition = [
    { data: "含早", title: this.$root.$t("mall.breakfastTxt"), code: "Hotel.Policy.GoodBreakfast", isChecked: false },
    { data: "双床", title: this.$root.$t("mall.TwinBed"), code: "Hotel.Spec.RoomBedType", isChecked: false },
    { data: "大床", title: this.$root.$t("mall.BigBed"), code: "Hotel.Spec.RoomBedType", isChecked: false },
    { data: "有窗", title: this.$root.$t("mall.withWindow"), code: "Hotel.Spec.RoomWindow", isChecked: false },
    { data: "限时取消", title: this.$root.$t("mall.timeToCancel"), code: "Hotel.Policy.GoodRefundRuleName", isChecked: false },
    { data: "符合政策", title: this.$root.$t("mall_hotel_hoteldetails_fuhezhengce"), code: "Hotel.TripRule.Qualified", isChecked: false },
  ];

  //computed
  get productDatas(): object {
    return this.$route.query;
  }

  get Consumers() {
    return this.$route.query.Consumers;
  }

  get Wheres() {
    return JSON.parse((this as any).$route.query.Wheres);
  }

  get DepartDate() {
    return this.$route.query.DepartDate;
  }
  get ArriveDate() {
    return this.$route.query.ArriveDate;
  }
  //mounted
  mounted() {
    this.isShowSkeleton = true;
    this.consumers = JSON.parse((this as any).Consumers);
    this.getDetailData();
    this.getHotelExtra();
    this.getApprovalExtra();
  }

  //methods
  getDetailData() {
    const query = this.$route.query;
    const data: object = {
      Wheres: this.Wheres,
      BookingType: query.BookingType,
      ApplyArea: query.ApplyArea,
      Consumers: this.consumers,
      CityCode: query.CityCode,
      ShoppingID: query.ShoppingID,
      ProductId: query.ProductId,
      cid: query.cid,
      hotelId: query.hotelId,
    };
    this.filterRoomDatas = [];
    HotelPolicyService.getProductDetail(data).then((res: any) => {
      if (res.isSucc) {
        this.isShowSkeleton = false;
        const products: any = res.result as object;
        if (products.Specs.length < 1) {
          this.$root.$toast(this.$root.$t("mall_hotel_hoteldetails_gaijiudianzanwuheshifangjian") as string);
          history.back();
          return;
        }
        _.forEach(products.Specs, item => {
          item.showStatus = false;
        });
        this.productDetailData = products;
        this.filterRooms();
        this.productImgs = (res.result as any).ProductImages.split(",") as string[];
      } else {
        this.$root.$toast(res.message);
        history.back();
      }
    });
  }
  filterRoomDatas = [];
  filterRooms(where?: any) {
    this.filterRoomDatas = [];
    let filters: any[] = [];
    if (where) {
      where.isChecked = !where.isChecked;
      filters = this.filterCondition.filter(o => o.isChecked);
    } else {
      //重置筛选条件
      this.filterCondition.forEach(o => (o.isChecked = false));
    }
    if (filters.length == 0) {
      this.filterRoomDatas = (this as any).productDetailData.Specs;
      return;
    }
    let rooms: any[] = _.clone((this as any).productDetailData.Specs);
    let newRoomes: any = _.filter(rooms, spec => {
      let extras = (this as any).productDetailData.Extras;
      let specExtras = _.filter(extras, el => el.IncludeId == spec.SpecId);

      for (let i = 0; i < filters.length; i++) {
        const matcher = filters[i];
        if (matcher.code == "Hotel.Spec.RoomWindow") {
          if (!_.find(specExtras, el => el.ExtraCode == matcher.code && el.ExtraData == matcher.data)) {
            return false;
          }
        } else if (matcher.code == "Hotel.Spec.RoomBedType") {
          if (!_.find(specExtras, el => el.ExtraCode == matcher.code && el.ExtraData && el.ExtraData.indexOf(matcher.data.substr(0, 1)) != -1)) {
            return false;
          }
        }
      }

      let throws = (this as any).productDetailData.Throws;
      throws = _.filter(throws, thr => thr.SpecId == spec.SpecId);
      throws = this.matchThrows(throws, filters);
      return throws && throws.length > 0;
    });
    this.filterRoomDatas = _.sortedUniq(newRoomes);
  }
  getChannelName(throwInfo: any) {
    let channelInfo = this.getChannelInfo(throwInfo);
    if (!channelInfo) {
      return undefined;
    }
    if (channelInfo.ChannelName) {
      return channelInfo.ChannelName;
    } else if (channelInfo.ChannelCode == "Contract") {
      return this.$root.$t("mall_hotel_hoteldetails_xieyijiudian") as string;
    }
    return undefined;
  }
  getChannelCode(throwInfo: any) {
    let channelInfo = this.getChannelInfo(throwInfo);
    if (channelInfo) {
      return channelInfo.ChannelCode;
    }
    return undefined;
  }
  getChannelInfo(throwInfo: any) {
    let policy = _.find((this.productDetailData as any).Policys, o => o.PolicyId == throwInfo.PolicyId);
    return policy;
  }

  getProductImg(): string[] {
    const result = _.filter(this.productImgs, item => item.indexOf("350_350") != -1);
    if (result.length > 10) {
      return result.slice(0, 9);
    }
    if (result.length > 2) {
      result.push(result[0]);
    }
    if (result.length == 0) {
      // result.push(require("../../../../static/img/errImg.png"));
    }
    return result;
  }

  getPrice(id: string): number {
    const priceArr: number[] = [];
    _.forEach((this as any).productDetailData.Throws, item => {
      if (item.SpecId === id) {
        priceArr.push(item.ThrowPrice);
      }
    });
    if (priceArr.length > 1) {
      return _.min(priceArr) as any;
    }
    return _.head(priceArr) as any;
  }

  getExtrasInfos(key: string, id: string): any {
    let extraCode = key;
    if (key == "area") {
      extraCode = "Hotel.Spec.RoomArea";
    } else if (key == "bedtype") {
      extraCode = "Hotel.Spec.RoomBedType";
    } else if (key == "window") {
      extraCode = "Hotel.Spec.RoomWindow";
      // extraCode = "Hotel.Throw.RoomWindow";
    } else if (key == "breakfast") {
      extraCode = "Hotel.Policy.GoodBreakfast";
    } else if (key == "RoomFloor") {
      extraCode = "Hotel.Spec.RoomFloor";
    }
    let extras = (this as any).productDetailData.Extras;
    // console.log(extras);
    let extra = _.find(extras, o => o.IncludeId == id && o.ExtraCode == extraCode);
    if (extra && extra.ExtraData && key == "RoomFloor") {
      return "楼层" + extra.ExtraData;
    }
    // let filters = _.filter(extras, o => o.IncludeId == id && o.ExtraCode == extraCode);
    return (extra && extra.ExtraData) || "";
  }

  matchThrows(throwDatas: any[], filters: any[]) {
    if (filters.length == 0 || throwDatas.length == 0) {
      return throwDatas;
    }
    let extras = (this as any).productDetailData.Extras;
    let result = _.filter(throwDatas, thr => {
      let thrExtras = _.filter(extras, el => thr.PolicyId == el.IncludeId);
      for (let i = 0; i < filters.length; i++) {
        const matcher = filters[i];
        if (matcher.code == "Hotel.Policy.GoodRefundRuleName") {
          if (!_.find(thrExtras, el => el.ExtraCode == matcher.code && el.ExtraData && el.ExtraData.indexOf(matcher.data.substr(0, 1)) != -1)) {
            return false;
          }
        } else if (matcher.code == "Hotel.Policy.GoodBreakfast") {
          if (!_.find(thrExtras, el => el.ExtraCode == matcher.code && el.ExtraData && parseInt(el.ExtraData) >= 1)) {
            return false;
          }
        } else if (matcher.code == "Hotel.TripRule.Qualified") {
          if (thr.Contrarys && thr.Contrarys.length > 0) {
            return false;
          }
        }
      }
      return true;
    });
    return this.sortPrices(result);
  }
  getThrows(id: string): any {
    let throwDatas = _.filter((this as any).productDetailData.Throws, item => item.SpecId === id);

    return this.matchThrows(
      throwDatas,
      this.filterCondition.filter(o => o.isChecked)
    );
  }
  sortPrices(priceList: any[]) {
    // 参数类型检查
    if (!Array.isArray(priceList)) {
        return [];
    }
    
    const [compliantPrices, nonCompliantPrices] = _.partition(priceList, item => {
        return !(item.Contrarys && item.Contrarys.length > 0);
    });
    
    // 简化排序逻辑
    const sortByPrice = (a: any, b: any) => (a.ThrowPrice || 0) - (b.ThrowPrice || 0);
    const yPrice = compliantPrices.sort(sortByPrice);
    const nPrice = nonCompliantPrices.sort(sortByPrice);
    // 分别排序并合并结果
    const result = yPrice.concat(nPrice);
    return result;
  }
  openMorePrices(id: string) {
    _.forEach((this as any).productDetailData.Specs, item => {
      if (item.SpecId === id) {
        item.showStatus = !item.showStatus;
      } else {
        item.showStatus = false;
      }
    });
  }
  breakfastDecorator(throwId: string,type?: string) {
    let extraData = this.getExtrasInfos("breakfast", throwId);
    let count = parseInt(extraData);
    if(type) {
      if (extraData == "" || count == 0 || isNaN(count)) {
        return 'Room Only';
      }else {
        return count;
      }
    };
    if (extraData == "" || count == 0 || isNaN(count)) {
      return this.$root.$t("mall_hotel_hoteldetails_wu") as string;
    } else if (count == 1) {
      return this.$root.$t("mall_hotel_hoteldetails_dan") as string;
    } else if (count == 2) {
      return this.$root.$t("mall_hotel_hoteldetails_shuang") as string;
    } else if (count > 2) {
      return this.$root.$t("mall_hotel_hoteldetails_duo") as string;
    } else {
      return extraData;
    }
  }

  isShowRules = false;
  overlayValue = [];
  showAmendRule(throwInfo: any) {
    var ruleDesc = this.getExtrasInfos("Hotel.Policy.GoodRefundRuleDes", throwInfo.PolicyId);
    this.overlayValue = ruleDesc.split("。");
    // this.$root.$toast(ruleDesc);
    this.isShowRules = true;
  }
  showContrarys(throwInfo: any) {
    let contrarys = (throwInfo.Contrarys || []).join(",");
    this.$root.$toast((this.$root.$t("mall_hotel_hoteldetails_weibei") as string) + contrarys);
  }

  gotoOrder(Throw: any): void {
    let __self = this;
    if (__self.isHideOverproof && Throw.Contrarys.length > 0) {
      Toast.fail(this.$root.$t("mall_hotel_hoteldetails_gaifangjianyinweibeiguizebukeyuding") as string);
      return;
    }

    const ProductID = (this as any).productDetailData.ProductId;
    const channelName = this.getChannelName(Throw);
    const query = this.$route.query;
    this.$root.$toast.loading({
      message: "验价中...",
      forbidClick: true,
    });

    if (channelName) {
      Dialog.confirm({
        title: this.$root.$t("mall_hotel_hoteldetails_wenxintishi") as string,
        message: this.$root.$t("mall_hotel_hoteldetails_bjdwxyjdknczfxqnzxbh") as string,
        closeOnPopstate: true,
      })
        .then(() => {
          gotoOrder();
        })
        .catch(() => {});
    } else {
      HotelPolicyService.productVerify({
        ProductId: ProductID,
        ThrowId: Throw.ThrowId,
        RoomNum: 1,
        ConsumerNum: __self.Consumers.length,
        ConsumerDate: __self.DepartDate as string,
        FinishedDate: __self.ArriveDate as string,
      }).then(response => {
        this.$root.$toast.clear();
        if (!response.isSucc) {
          Toast.fail(response.message);
          return;
        }
        gotoOrder();
      });
    }
    // const = _.find((this as any).productDetailData.Throws, (item: any) => item.SpecId == spec.SpecId);
    function gotoOrder() {
      __self.$router.push({
        path: "/mall/hotel/order",
        query: {
          ProductId: ProductID,
          BookingType: query.BookingType,
          PolicyID: Throw.PolicyId,
          ThrowID: Throw.ThrowId,
          ServiceType: ServiceType.HotelService.toString(),
          ApplyArea: ApplyArea.Internal.toString(),
          DepartDate: __self.DepartDate,
          ArriveDate: __self.ArriveDate,
          Consumers: __self.Consumers,
          approvalCode:query.approvalCode,
          roomNumber:query.roomNumber,
        },
      });
    }
    // this.$root.$toast.loading({
    //   message: "预定中...",
    //   forbidClick: true,
    // });
  }

  //隐藏违背政策的产品
  get FeatureCodes() {
    return this.$route.query.FeatureCodes || "";
  }
  get isHideOverproof() {
    return this.FeatureCodes.indexOf("HideProduct") > -1;
  }
  isShowGood(goodId: any, index: number) {
    let good = _.find((this as any).productDetailData.Throws, item => {
      return item.SpecId == goodId;
    });
    //差旅政策规定 隐藏违背政策的产品 违背政策的商品 且 不是第一条
    if (this.isHideOverproof && good.Contrarys.length > 0 && index > 0) {
      return false;
    }
    return true;
  }
  isShowThrow(Throw: any, index: number) {
    //差旅政策规定 隐藏违背政策的产品 违背政策的商品 且 不是第一条
    if (this.isHideOverproof && Throw.Contrarys.length > 0 && index > 0) {
      return false;
    }
    return true;
  }

  back() {
    history.back();
  }
  showMap(Detail: any) {
    let __self = this;
    __self.$router.push({
      path: "/webMap",
      query: {
        title: Detail.ProductName,
        latitude: Detail.EnterLatitude,
        longitude: Detail.EnterLongitude,
      },
    });
  }
  hotelIcon(Throw: any){
      const Policys  = (this.productDetailData as any).Policys;
      const PolicyId = Throw.PolicyId;
      const hotelConfigInfo = this.hotelConfigInfo;
      const ChannelCode = _.find(Policys, o => o.PolicyId == PolicyId).ChannelCode || '';
      if(ChannelCode == 'Contract') return '';
      if(hotelConfigInfo){
       // 定义须排除的配置
       const excludeTypes = ['HUAZHU'];

       let hotelTypes = hotelConfigInfo.split(',');
       let showIcon = hotelTypes.find(item => item !== 'Other' && ChannelCode.includes(item));
       if(showIcon) return ChannelCode;

       if(hotelTypes.includes('Other')) {
          // 检查当前 ChannelCode 是否属于须排除的配置
          const isExplicitOnly = excludeTypes.some(key => ChannelCode.includes(key));
          if(isExplicitOnly) return '';
          return ChannelCode;
       }
       return '';
      }
      return ''; 
  }
  getAssetsFile(fileName: string) {
      return require(`@/assets/hotel-icon/${fileName}.png`);
  }
  hotelConfigInfo = '';
  getHotelExtra(){     
   let __self=this;
   let data = {
    ExtraCode:'company.HotelGroup',
    MasterID:__self.profile.CompanyID || ''
   };
   SystemService.getCompanyExtra(data).then(p=>{
     if(p.isSucc){
        const btrip=p.result;
        if(btrip && btrip.ExtraCode === 'company.HotelGroup'){
          if(btrip.ExtraData){
             __self.hotelConfigInfo = btrip.ExtraData || '';
          }
        }
     }
   })
  }
  resetTranslate(text:string){
          let result = String(text);
          const rules: Array<[RegExp, string]> = [
            [/有窗/g, `${this.$t("mall_hotel_hoteldetails_youchuang")}`],
            [/无窗/g, `${this.$t("mall_hotel_hoteldetails_wuchuang")}`],
            [/限时取消/g, `${this.$t("mall_hotel_hoteldetails_xianshiquxiao")}`],
            [/不可取消/g, `${this.$t("mall_hotel_hoteldetails_bukequxiao")}`],
          ];
          if (typeof result !== 'string') {
              return text;
          }
          for (const [pattern, replacement] of rules) {
            result = result.replace(pattern, replacement);
          }
          return result;
  }
  resetProductName(productName: string){
    if (!productName) {
      return { name: '', hasHuazhu: false };
    }
    const regex = /\(华住\)/g;
    const hasHuazhu = regex.test(productName);
    const processedName = productName.replace(regex, '');

    return { 
      name: processedName, // 处理后的酒店名称
      hasHuazhu: hasHuazhu // 是否包含华住标识
    };
  }
  disabledReserve:boolean = false;
  getApprovalExtra(){
    let __self=this;
    let data={
      ExtraCode:'company.ApprovalInfoSetting',
      MasterID:__self.profile.CompanyID || ''
    };
    SystemService.getCompanyExtra(data).then(p=>{
      if(p.isSucc){
        const data=p.result;
        if(data && data.ExtraData){
          __self.disabledReserve=data.ExtraData.indexOf('selectApprovalBooking')>-1 || false;
        }
      }
    })
  }
  showHint(){
    Dialog.alert({
      title: "温馨提示",
      message: "请选择审批单进行预定！",
      confirmButtonText: "我已知晓",
    }).then(() => {
    });
  }
}
